require('./contractInfo.scss');
// @ vendor
const React = require('react');
const PropTypes = require('prop-types');

// @ commons
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { FormattedText } = require('core/i18n').i18n;
const { LoadingSection } = require('commonsComponents/loadingSection');


class ContractInfo extends React.Component {
    render() {
        const { immCard } = this.props;
        const contractNumber = immCard.get('fullContractNumber');
        const ownerName = immCard.get('titularName');

        if(!immCard) {
            return (
                <OKSectionBox>
                    <LoadingSection/>
                </OKSectionBox>
            );
        }
        else {
            return (
                <OKSectionBox className="contract-info">
                    <h1 className="contract-info__title">
                        <FormattedText value="contractInfo-title"/>
                    </h1>
                    <section className="contract-info__field">
                        <h2 className="contract-info__subtitle">
                            <FormattedText value="contractInfo-contractNumber"/>
                        </h2>
                        <div className="contract-info__value">
                            {contractNumber}
                        </div>
                    </section>
                    <section className="contract-info__field">
                        <h2 className="contract-info__subtitle">
                            <FormattedText value="contractInfo-owner"/>
                        </h2>
                        <div className="contract-info__value">
                            {ownerName}
                        </div>
                    </section>
                </OKSectionBox>
            );
        }
    }
}
ContractInfo.propTypes = {
    immCard: PropTypes.object,
}

module.exports = ContractInfo;
